class BottomBarMenuGoBackButtonListener extends AbstractInputListener
{

    listen()
    {
        let context = this;
        $(document).on('click', context.selector, function (){

            let url = window.location.href;

            if(url.includes('passenger-elements'))
                $('.minified_booking_nav_tabs a:eq(0)').trigger('click');

            if(url.includes('auth-search'))
            {
                $('#append_rides').empty();
                $('#ride_search_collapse').addClass('in');
                $('#ride_search_panel').removeClass('hide');

                $('.load_more_rides_component').addClass('hide');

                let locked_ride_stations = new LockedRideStationsInterface();
                locked_ride_stations.getComponent();
            }

            if(url.includes('minified-booking/choose-second-way'))
            {
                window.location.href = laroute.route('ticketavis_minified_booking.search');
            }

        });



    }

}